import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ApolloProvider, gql, useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useStore } from './store';
import { apolloClient } from './utils/apollo';
import Navbar from './components/Layout/Navbar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Events from './pages/Events';
import Statistics from './pages/Statistics';
import Devices from './pages/Devices';
import Whitelist from './pages/Whitelist';
import Zones from './pages/Zones';
import Settings from './pages/Settings';
import NodePage from './pages/NodePage';
import Onboarding from './pages/Onboarding';
import Console from './pages/Console';
import WorldMap from './pages/WorldMap';
import Integrate from './pages/Integrate';
import Billing from './pages/Billing';
import CloudStatusPoll from './components/CloudStatusPoll';
import './App.css';
const GET_PARTNER_BRANDING = gql`
  query GetPartnerBranding($domain: String!) {
    getPartnerBranding(domain: $domain) {
      companyName
      primaryColor
      accentColor
      logoUrl
      faviconUrl
    }
  }
`;
function BrandingLoader() {
  const setBranding = useStore((s) => s.setBranding);
  const { data } = useQuery(GET_PARTNER_BRANDING, {
    variables: { domain: window.location.hostname },
    fetchPolicy: 'cache-first',
  });
  useEffect(() => {
    if (data?.getPartnerBranding) {
      const b = data.getPartnerBranding;
      setBranding(b);
      const root = document.documentElement;
      if (b.primaryColor) root.style.setProperty('--primary-color', b.primaryColor);
      if (b.accentColor) root.style.setProperty('--accent-color', b.accentColor);
      if (b.companyName) document.title = b.companyName;
    }
  }, [data, setBranding]);
  return null;
}
function PrivateRoute({ children }: { children: React.ReactNode }) {
  const token = useStore(s => s.token);
  const location = useLocation();
  // Куда шёл пользователь: со внутренней страницы пульта страница входа сразу откроет форму Defense
  // и после входа вернёт туда же. С корня «/» — обычный выбор сервиса.
  const from = location.pathname === '/' ? undefined : location.pathname + location.search;
  return token ? <>{children}</> : <Navigate to="/login" replace state={from ? { from } : undefined} />;
}
function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="app-shell"><CloudStatusPoll />
      <Navbar />
      <main className="app-main">{children}</main>
    </div>
  );
}
export default function App() {
  return (
    <ApolloProvider client={apolloClient}>
      <BrandingLoader />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><AppLayout><Dashboard /></AppLayout></PrivateRoute>} />
          <Route path="/events" element={<PrivateRoute><AppLayout><Events /></AppLayout></PrivateRoute>} />
          <Route path="/statistics" element={<PrivateRoute><AppLayout><Statistics /></AppLayout></PrivateRoute>} />
          <Route path="/devices" element={<PrivateRoute><AppLayout><Devices /></AppLayout></PrivateRoute>} />
          <Route path="/whitelist" element={<PrivateRoute><AppLayout><Whitelist /></AppLayout></PrivateRoute>} />
          <Route path="/zones" element={<PrivateRoute><AppLayout><Zones /></AppLayout></PrivateRoute>} />
          <Route path="/node" element={<PrivateRoute><AppLayout><NodePage /></AppLayout></PrivateRoute>} />
          <Route path="/integrate" element={<PrivateRoute><AppLayout><Integrate /></AppLayout></PrivateRoute>} />
          <Route path="/console" element={<PrivateRoute><AppLayout><Console /></AppLayout></PrivateRoute>} />
          <Route path="/world" element={<PrivateRoute><AppLayout><WorldMap /></AppLayout></PrivateRoute>} />
          <Route path="/management" element={<PrivateRoute><AppLayout><Onboarding /></AppLayout></PrivateRoute>} />
          <Route path="/billing" element={<PrivateRoute><AppLayout><Billing /></AppLayout></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><AppLayout><Settings /></AppLayout></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ApolloProvider>
  );
}
